import Axios, { AxiosInstance } from "axios";
import { AuthInjector, RedirectUnauthorize } from "./interceptors";
import { AppRoutesUI } from "../../config/appRoutes";
import { apiConfig } from "../../config/apiConfig";

const createAxiosAuthInstance = (baseURL = process.env.REACT_APP_API) => {
  const token = localStorage.getItem("token");

  const instance = Axios.create({
    baseURL,
    headers: {
      authorization: "Bearer " + token,
    },
  });

  AuthInjector.Add(instance);

  RedirectUnauthorize.Add(instance, AppRoutesUI.Auth.Login.Path(), () => {
    localStorage.clear();
  });

  return instance;
};

const axiosAuthInstancesByBaseUrl = new Map<string, AxiosInstance>();

const AxiosAuth = createAxiosAuthInstance(apiConfig.liveBaseUrl);

const createScopedAxiosAuth = (baseURL = apiConfig.liveBaseUrl) => {
  const normalizedBaseUrl = baseURL ?? apiConfig.liveBaseUrl;

  if (!normalizedBaseUrl) {
    throw new Error("Missing API base URL for scoped axios client");
  }

  if (normalizedBaseUrl === apiConfig.liveBaseUrl) {
    return AxiosAuth;
  }

  const existingInstance = axiosAuthInstancesByBaseUrl.get(normalizedBaseUrl);
  if (existingInstance) {
    return existingInstance;
  }

  const nextInstance = createAxiosAuthInstance(normalizedBaseUrl);
  axiosAuthInstancesByBaseUrl.set(normalizedBaseUrl, nextInstance);
  return nextInstance;
};

export { AxiosAuth, createScopedAxiosAuth };
